import useFetcher from "@/utils/use-fetcher";
import {
  createOrderSheetSetKey,
  CreateOrderSheetSetRequest,
  CreateOrderSheetSetResponse,
} from "@/features/line-sheet-sets/hooks/use-create-order-sheet-set";
import useYWRInfinite from "@/features/ui/hooks/use-ywr-inifite";

export default function useCreateOrderSheetSetInfinite() {
  const fetcher = useFetcher<
    CreateOrderSheetSetRequest,
    CreateOrderSheetSetResponse
  >();
  return useYWRInfinite(createOrderSheetSetKey, fetcher);
}
